import { DecimalPipe } from "@angular/common";
import { Component, inject, Input, ChangeDetectionStrategy } from "@angular/core";
import { InputComponent } from "~app/common/components/input/input.component";
import { MapPopupContentComponent } from "~app/common/components/map/components/widgets/map-popup/map-popup-content/map-popup-content.component";
import { IMapComponent } from "~app/common/components/map/map.models";
import { IMapDrawLayer, IMapGeometry, IMapGeometryWicket } from "~app/common/components/map/map.settings";
import { SpatialService } from "~app/common/components/map/services/spatial.service";
import { TransportforetagRedigeraService } from "../services/transportforetag-redigera.service";
import { ITransportforetagRedigeraPopupData } from "./transportforetag-redigera.model";

@Component({
    selector: "rask-transportforetag-redigera-popup",
    imports: [
        MapPopupContentComponent,
        InputComponent,
        DecimalPipe
    ],
    templateUrl: "./transportforetag-redigera-popup.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./transportforetag-redigera-popup.component.scss"]
})
export class TransportforetagRedigeraPopupComponent {

    map: IMapComponent;

    @Input() set data(value: ITransportforetagRedigeraPopupData) {
        this.geometry = value.geometri;
        this.figurAreal = this.getAreal(value.geometri);
        this.header = value.geometri.label;
        this.redigeraLager = value.layer;
        this.canEdit = value.canEdit;
    }

    @Input() onClose: () => void;

    protected canEdit = false;
    protected figurAreal: number;
    protected header: string;
    private readonly spatialService = inject(SpatialService);
    private readonly transportforetagRedigeraService = inject(TransportforetagRedigeraService);
    private redigeraLager: IMapDrawLayer;
    private geometry: IMapGeometry;

    protected handleAbort = (): void => {
        this.onClose();
    };

    protected handleEdit = (): void => {
        this.onClose();
        this.map.getSketch().edit(this.redigeraLager,
            this.geometry, (g: IMapGeometryWicket) => this.transportforetagRedigeraService.editTransportomrade(g), true);
        this.map.getSketch().onAbort(() => {
            this.onClose();
        });
    };

    protected handleDelete = (): void => {
        this.transportforetagRedigeraService.deleteTransportomrade(this.geometry);
        this.onClose();
    };

    private getAreal(geometri: IMapGeometry): number {
        return this.spatialService.getArea(geometri, "hectares");
    }
}
